import React from 'react';
import { Box } from '@mui/material';
import { useRecoilState } from 'recoil';
import ApplicationSection from 'pages/reference-implementation/provisioning/RI003O/components/sections/Application';
import AccessMgmtSection from 'pages/reference-implementation/provisioning/RI003O/components/sections/AccessMgmtSection';
import ResourceMgmtSection from 'pages/reference-implementation/provisioning/RI003O/components/sections/ResourceMgmtSection';
import { OrderPayload, isBudgetCodeValid, budgetCodeValidationModal } from 'pages/reference-implementation/provisioning/RI003O/store';
import BudgetCodeValidationModal from 'pages/provisioning/_components/StackProvisioning/Form/BudgetCodeValidationModal';

const IndexForm = () => {
    const [, setOrder] = useRecoilState(OrderPayload);
    const [, setBudgetCodeValid] = useRecoilState(isBudgetCodeValid);
    const [budgetCodeValidation, setBudgetCodeValidation] = useRecoilState(budgetCodeValidationModal);

    const closeBudgetCodeValidation = (isAccepted) => {
        if (isAccepted) setOrder((prev) => ({ ...prev, enabledManualBudgetCode: true }));
        setBudgetCodeValid(isAccepted);
        setBudgetCodeValidation({ open: false, budgetCode: '' });
    };
    return (
        <Box flex={3} data-testid="index-form">
            <ApplicationSection />
            <ResourceMgmtSection />
            <AccessMgmtSection />
            <BudgetCodeValidationModal
                open={budgetCodeValidation.open}
                budgetCode={budgetCodeValidation.budgetCode}
                onContinue={() => closeBudgetCodeValidation(true)}
                onCancel={() => closeBudgetCodeValidation(false)}
            />
        </Box>
    );
};

export default IndexForm;
